import type { FaireProductEntity } from "../../entity_types/product";

export const p_vuuxsd3chx: FaireProductEntity = {
  token: "p_vuuxsd3chx",
  type: "product",
  name: "Cozy Cabin 1.5 oz Mini Mason Jar Soy Candle",
  brandName: "Flameworks Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/36ad521ff7bcb3d5baefc6702b642bfcb7101250763bfe0d11e40df0aa8b4735.jpeg",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2af3ef17f7a55bc3dee60cdde1340e764709c34071c502e72db6686135cdc5c2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
